var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIntroToAzureVirtualMachines(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "introduction-to-azure-virtual-machines") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-1.4%",
    y: "-1.3%",
    width: "102.8%",
    height: "105.2%",
    filterUnits: "objectBoundingBox",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.104562953 0",
    type: "matrix",
    in: "shadowOffsetOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("polygon", {
    id: "path-2",
    points: "56.9855779 10.5555954 21.0500648 30.5163335 13.6030796 26.2834269 49.0669785 6.10865185"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-1.2%",
    y: "-2.0%",
    width: "102.3%",
    height: "108.2%",
    filterUnits: "objectBoundingBox",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.0979110054 0",
    type: "matrix",
    in: "shadowOffsetOuter1"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-4",
    points: "13.5500326 10.5555954 21.468632 6.10865185 56.9325309 26.2834269 49.4855457 30.5163335"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-1.2%",
    y: "-2.0%",
    width: "102.3%",
    height: "108.2%",
    filterUnits: "objectBoundingBox",
    id: "filter-5"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.0979110054 0",
    type: "matrix",
    in: "shadowOffsetOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Badges-FINAL",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Adminster-infrastructure-resources-in-Azure",
    transform: "translate(-576.000000, -348.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "introduction-to-azure-virtual-machines",
    transform: "translate(576.000000, 348.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "BG",
    fill: "#D9EAF8",
    x: 2,
    y: 2,
    width: 96,
    height: 96,
    rx: 48
  }), /*#__PURE__*/React.createElement("g", {
    id: "Virtual-Machine",
    filter: "url(#filter-1)",
    transform: "translate(15.500000, 11.753735)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Bulb",
    fill: "#30404D",
    opacity: 0.100000001,
    cx: 35.6056598,
    cy: 39.9782847,
    r: 31.3029551
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Front-Copy-4",
    fill: "#362D56",
    points: "28.4542885 67.2005536 21.0500648 71.1414501 13.6030796 66.7989496 20.5356891 62.7536101"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Front-Copy-6",
    fill: "#362D56",
    points: "56.9855779 10.5577577 56.9855779 20.9773186 49.5508687 16.6356549 49.5508687 6.40291798"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Front-Copy-4",
    fill: "#362D56",
    points: "42.081322 67.2005536 49.9999214 62.7536101 56.9325309 66.7989496 49.4855457 71.1414501"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Front-Copy-6",
    fill: "#362D56",
    points: "13.5500326 10.5577577 20.9847418 6.40291798 20.9847418 16.6356549 13.5500326 20.9773186"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Cube",
    transform: "translate(0.091229, 0.485287)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Right",
    transform: "translate(36.386055, 22.201660)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.9878091,0.991011051 L1.24208664,16.7618297 C0.585438102,17.1350723 0.179814961,17.8322004 0.179814961,18.5875131 L0.179814961,49.9460408 C0.179814961,51.1058388 1.12001699,52.0460408 2.27981496,52.0460408 C2.65152207,52.0460408 3.01656899,51.9473803 3.33767004,51.7601363 L30.636759,35.8411953 C31.5586331,35.303622 32.1255375,34.3167932 32.1255375,33.2496302 L32.1255375,2.81669447 C32.1255375,1.65689649 31.1853354,0.716694466 30.0255375,0.716694466 C29.6617054,0.716694466 29.304115,0.811221111 28.9878091,0.991011051 Z",
    id: "Back",
    fill: "#50398A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1146798,1.65119271 L2.36895729,17.4220114 C1.71230875,17.7952539 1.30668561,18.492382 1.30668561,19.2476948 L1.30668561,50.6062225 C1.30668561,51.7660204 2.24688763,52.7062225 3.40668561,52.7062225 C3.77839272,52.7062225 4.14343964,52.6075619 4.46454069,52.420318 L31.7636296,36.5013769 C32.6855038,35.9638037 33.2524081,34.9769749 33.2524081,33.9098119 L33.2524081,3.47687613 C33.2524081,2.31707815 32.3122061,1.37687613 31.1524081,1.37687613 C30.788576,1.37687613 30.4309856,1.47140277 30.1146798,1.65119271 Z",
    id: "Front",
    fill: "#6D56A6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Left",
    transform: "translate(0.616713, 22.201660)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.63754406,2.81714543 L1.63754406,33.2243616 C1.63754406,34.2908523 2.20374022,35.2771649 3.12469622,35.8149776 L30.574874,51.8451194 C31.5287125,52.4021346 32.7535014,52.0804457 33.3105166,51.1266072 C33.4892508,50.820541 33.5834392,50.4724746 33.5834392,50.118042 L33.5834392,18.587977 C33.5834392,17.8326625 33.1778142,17.1355331 32.5211633,16.7622912 L4.77526814,0.991459605 C3.7669697,0.41834042 2.48497742,0.771122909 1.91185824,1.77942135 C1.73206985,2.09572615 1.63754406,2.45331498 1.63754406,2.81714543 Z",
    id: "Back",
    fill: "#684DAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.443287702,3.50384767 L0.443287702,33.9110638 C0.443287702,34.9775545 1.00948386,35.9638671 1.93043986,36.5016798 L29.3806176,52.5318216 C30.3344561,53.0888368 31.559245,52.767148 32.1162602,51.8133095 C32.2949944,51.5072432 32.3891829,51.1591769 32.3891829,50.8047443 L32.3891829,19.2746792 C32.3891829,18.5193647 31.9835579,17.8222353 31.326907,17.4489934 L3.58101178,1.67816185 C2.57271335,1.10504266 1.29072106,1.45782515 0.717601878,2.46612359 C0.537813489,2.78242839 0.443287702,3.14001722 0.443287702,3.50384767 Z",
    id: "Front",
    fill: "#8066C0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Top",
    transform: "translate(3.933702, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.64903547,20.2989674 L30.0311632,36.44505 C30.8892686,36.9332108 31.9410342,36.9334002 32.7993154,36.4455485 L61.1947936,20.3054052 C61.8669917,19.9233242 62.102178,19.0686621 61.720097,18.396464 C61.5931851,18.1731868 61.4073004,17.9891222 61.1827854,17.8644131 L32.2299726,1.78228527 C31.6230908,1.44518678 30.8848102,1.44690936 30.2795082,1.78683616 L1.65577828,17.8614101 C0.981612987,18.2400093 0.74200929,19.0934435 1.12060844,19.7676088 C1.24519372,19.9894557 1.42788116,20.1731567 1.64903547,20.2989674 Z",
    id: "Back",
    fill: "#7454B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.64903547,19.0655418 L30.0311632,35.2116244 C30.8892686,35.6997852 31.9410342,35.6999746 32.7993154,35.2121229 L61.1947936,19.0719796 C61.8669917,18.6898986 62.102178,17.8352365 61.720097,17.1630385 C61.5931851,16.9397613 61.4073004,16.7556966 61.1827854,16.6309875 L32.2299726,0.548859695 C31.6230908,0.211761201 30.8848102,0.213483783 30.2795082,0.553410586 L1.65577828,16.6279845 C0.981612987,17.0065837 0.74200929,17.8600179 1.12060844,18.5341832 C1.24519372,18.7560301 1.42788116,18.9397311 1.64903547,19.0655418 Z",
    id: "Front",
    fill: "#A684D3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Front-Copy-3"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-3)",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#6D56A6",
    fillRule: "evenodd",
    xlinkHref: "#path-2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Front-Copy-3"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-5)",
    xlinkHref: "#path-4"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#6D56A6",
    fillRule: "evenodd",
    xlinkHref: "#path-4"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Front-Copy-5",
    fill: "#3F365D",
    points: "21.064881 30.4217207 21.064881 71.1414501 13.6301718 66.7997863 13.6301718 26.1958147"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Front-Copy-5",
    fill: "#3F365D",
    points: "49.4707295 30.4217207 56.9054386 26.1958147 56.9054386 66.7997863 49.4707295 71.1414501"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Azure-Border",
    stroke: "#0078D4",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 96,
    height: 96,
    rx: 48
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntroToAzureVirtualMachines);
export default __webpack_public_path__ + "static/media/intro-to-azure-virtual-machines.12ec8f0c743cb9268dbac996d5e9b6b7.svg";
export { ForwardRef as ReactComponent };